import { AppRoutes } from '@/constants/appRoutes'
import type { StepGuardEvalContext } from '@/hooks/createStepGuard'
import { EFollowUpStep } from '@/pages/FollowUpReport/types'
import type { RunReportSliceState } from '@/store/api/RunReport/RunReport.slice'

const hasReportId = (searchParams: URLSearchParams) =>
  !!searchParams.get('reportId')

type Predicate = (
  evalContext: StepGuardEvalContext<RunReportSliceState>,
) => boolean

export const STEP_PREREQUISITES: Record<EFollowUpStep, Predicate> = {
  [EFollowUpStep.Report]: ({ searchParams }) => hasReportId(searchParams),
  [EFollowUpStep.UseCase]: ({ searchParams }) => hasReportId(searchParams),
  [EFollowUpStep.Consent]: ({ searchParams }) => hasReportId(searchParams),
  [EFollowUpStep.LegalDisclaimer]: ({ searchParams }) =>
    hasReportId(searchParams),
}

export const STEP_FALLBACK_ROUTE: Record<EFollowUpStep, AppRoutes> = {
  [EFollowUpStep.Report]: AppRoutes.reports,
  [EFollowUpStep.UseCase]: AppRoutes.reports,
  [EFollowUpStep.Consent]: AppRoutes.reports,
  [EFollowUpStep.LegalDisclaimer]: AppRoutes.reports,
}
